package ru.it_mozaika.sender.js.application.frames

import mui.material.*
import mui.system.sx
import react.ReactNode
import react.create
import react.rawForwardRef
import web.cssom.*
import web.html.HTMLDivElement

external interface MainCardProps: CardProps{
    var actions: ReactNode?
}
val MainCard = rawForwardRef<HTMLDivElement, MainCardProps> { p, r ->
    Card.create {
        ref = r
        sx {
            ":hover" {
                boxShadow = web.cssom.BoxShadow(0.px, 2.px, 14.px, 0.px, Color("rgb(32 40 45 / 8%)"))
            }
            +p.sx
        }
        +p
        p.title?.let {
            CardHeader {
                title = ReactNode(p.title)
                if (undefined != p.actions) {
                    this.action = CardActions.create() {
                        +p.actions
                    }
                }
            }
            Divider()
        }
        CardContent {
            +p.children
        }
    }
}